import { render, staticRenderFns } from "./examheader.vue?vue&type=template&id=515632c6&scoped=true&"
import script from "./examheader.vue?vue&type=script&lang=js&"
export * from "./examheader.vue?vue&type=script&lang=js&"
import style0 from "./examheader.vue?vue&type=style&index=0&id=515632c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515632c6",
  null
  
)

export default component.exports